import { InvoiceApprovalStatus } from '../globalEnums';

export function isAwaitingSubmissionInvoice(invoice) {
  return (
    invoice.sourceMethod === 'Manual' &&
    !invoice.submittingLocked &&
    invoice.approvalStatus === InvoiceApprovalStatus.Approved &&
    invoice.queInfo == null &&
    invoice.bookingRejection !== true
  );
}

export function isInvoiceInQueue(invoice) {
  return invoice.queInfo !== null;
}

export function isRejectedInvoice(invoice) {
  return invoice.bookingRejection === true || invoice.approvalStatus === InvoiceApprovalStatus.Rejected;
}

export function isUserPendingInvoice(invoice, userEmail) {
  const userEmailLowerCase = userEmail?.toLowerCase();
  return (
    invoice.queInfo == null &&
    invoice.bookingRejection !== true &&
    (invoice.sourceMethod === 'Manual'
      ? invoice.addedBy?.toLowerCase() === userEmailLowerCase ||
      (!invoice.submittingLocked && invoice.approvalStatus !== InvoiceApprovalStatus.Pending) ||
      invoice.approvers?.some(t => t.status === 1 && t.approverEmail?.toLowerCase() === userEmailLowerCase)
      : invoice?.facilityManagerAssignments.some((fma) => fma.currentUser))
  );
}